<script setup>
import { useHead } from '@unhead/vue';

const structuredData = {
  "@context": "https://schema.org",
  "@type": "Dentist",
  "name": "Senyum Dental Clinic",
  "description": "Professional dental clinic offering comprehensive dental services including implants, whitening, and consultations. Expert dentists providing quality care for all your dental needs.",
  "url": "https://senyum-dental-clinic.com",
  "telephone": "+60-123-456789", // Replace with actual phone number
  "email": "info@senyum-dental-clinic.com", // Replace with actual email
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "123 Dental Street", // Replace with actual address
    "addressLocality": "Kuala Lumpur",
    "addressRegion": "KL",
    "postalCode": "50000",
    "addressCountry": "MY"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "3.1390", // Replace with actual coordinates
    "longitude": "101.6869"
  },
  "openingHours": [
    "Mo-Fr 09:00-18:00",
    "Sa 09:00-16:00"
  ],
  "priceRange": "$$",
  "paymentAccepted": ["Cash", "Credit Card", "Insurance"],
  "currenciesAccepted": "MYR",
  "sameAs": [
    "https://www.facebook.com/senyumdental", // Replace with actual social media URLs
    "https://www.instagram.com/senyumdental"
  ],
  "services": [
    {
      "@type": "MedicalProcedure",
      "name": "Dental Implants",
      "description": "Professional dental implant services for permanent tooth replacement"
    },
    {
      "@type": "MedicalProcedure",
      "name": "Teeth Whitening",
      "description": "Professional teeth whitening services for a brighter smile"
    },
    {
      "@type": "MedicalProcedure",
      "name": "Root Canal Treatment",
      "description": "Expert root canal treatment to save damaged teeth"
    },
    {
      "@type": "MedicalProcedure",
      "name": "Dental Consultation",
      "description": "Comprehensive dental consultations and check-ups"
    }
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8", // Replace with actual rating
    "reviewCount": "150" // Replace with actual review count
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Dental Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "MedicalProcedure",
          "name": "Dental Consultation"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "MedicalProcedure",
          "name": "Dental Implants"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "MedicalProcedure",
          "name": "Teeth Whitening"
        }
      }
    ]
  },
  "medicalSpecialty": "Dentistry",
  "availableServiceType": [
    "General Dentistry",
    "Cosmetic Dentistry",
    "Implant Dentistry",
    "Preventive Dentistry"
  ]
};

// Add structured data to head
useHead({
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify(structuredData, null, 2)
    }
  ]
});
</script>

<template>
  <!-- This component only adds structured data to the head, no visible content -->
</template>
